import React, { useState, SetStateAction } from 'react';
import styled from 'styled-components';
import FaqTopicItemList from './components/FaqTopicItemList';
import FaqItemList from './components/FaqItemList';
import TestimonialSection from '../../components/TestimonialSection';
import BREAK_POINTS from '../../styling/media-queries';
import { FaqTopic, Faq } from './models';
import { useScrollResetter, useAdobeAnalytics } from 'packages/smart-home-support/hooks';

const PARTNER_CODE = globals.REACT_APP_PARTNER;

const faqTopics: FaqTopic[] = require(`./resources/data/${PARTNER_CODE}/faq-topics.json`);
const faqs: Faq[] = require(`./resources/data/${PARTNER_CODE}/faqs.json`);

const mobileMargins: string = '30px 15px 0px 15px';
const mobileBigMargins: string = '60px 30px 0px 30px';
const tabletMargins: string = '60px 60px 0px 60px';
const tabletBigMargins: string = '60px 30px 0px 30px';
const desktopMargins: string = '90px 90px 0px 90px';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  z-index: -1;
  max-width: 100%;
`;

const FaqContainer = styled.div`
  margin: ${mobileMargins};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 100%;

  @media ${BREAK_POINTS.mobileBig} {
    margin: ${mobileBigMargins};
  }

  @media ${BREAK_POINTS.tablet} {
    margin: ${tabletMargins};
  }

  @media ${BREAK_POINTS.tabletBig} {
    margin: ${tabletBigMargins};
    flex-direction: row;
  }

  @media ${BREAK_POINTS.desktop} {
    margin: ${desktopMargins};
  }
`;

const FaqTopicListContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media ${BREAK_POINTS.tabletBig} {
    min-width: 400px;
    max-width: 400px;
  }
`;

const FaqHeading = styled.div`
  margin-bottom: 60px;
  font-style: normal;
  font-weight: bold;
  line-height: 44px;
  font-size: 44px;
  text-align: center;
  letter-spacing: -0.3px;
  color: #252525;

  @media ${BREAK_POINTS.tabletBig} {
    text-align: left;
  }
`;

const FaqItemListContainer = styled.div`
  margin-top: 50px;
  margin-bottom: 90px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  width: 100%;

  @media ${BREAK_POINTS.tabletBig} {
    margin-top: 0px;
    margin-left: 60px;
    max-width: 800px;
  }
`;

export const FaqPage: React.FunctionComponent = () => {
  const [selectedFaqTopic, setSelectedFaqTopic]: [number, React.Dispatch<SetStateAction<number>>] = useState<number>(1);

  useScrollResetter();
  useAdobeAnalytics();

  return (
    <>
      <Container>
        <FaqContainer>
          <FaqTopicListContainer>
            <FaqHeading>Frequently asked questions</FaqHeading>
            <FaqTopicItemList
              faqTopics={faqTopics}
              selectedFaqTopic={selectedFaqTopic}
              setSelectedFaqTopic={setSelectedFaqTopic}
            />
          </FaqTopicListContainer>
          <FaqItemListContainer>
            <FaqItemList selectedFaqTopic={selectedFaqTopic} faqs={faqs} />
          </FaqItemListContainer>
        </FaqContainer>
      </Container>
    </>
  );
};

export default FaqPage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/faqpage/index.tsx